import { useFamilyRemovalDetection } from '@/hooks/useFamilyRemovalDetection';
import ModalBackdrop from './ModalBackdrop';
import { AlertCircle } from 'lucide-react';

export default function FamilyRemovalNotification() {
  const { showRemovedModal, handleAcknowledge } = useFamilyRemovalDetection();

  if (!showRemovedModal) return null;

  return (
    <ModalBackdrop>
      <div className="w-full max-w-md rounded-xl bg-card border border-border p-6 my-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-lg bg-orange-500/20">
            <AlertCircle className="h-6 w-6 text-orange-500" />
          </div>
          <h2 className="text-xl font-semibold">Du har blivit borttagen från familjen</h2>
        </div>
        <p className="text-muted-foreground mb-6">
          Du är inte längre medlem i familjen och arbetar nu mot din egen beredskapsprofil igen.
        </p>
        <button
          onClick={handleAcknowledge}
          className="w-full px-4 py-2 rounded-lg text-white hover:opacity-90 transition-all"
          style={{ backgroundColor: '#67724e' }}
        >
          OK
        </button>
      </div>
    </ModalBackdrop>
  );
}
